import { AccessGroupItemsValues, AccessGroupValues } from './types';

export const ACCESS_GROUP_ITEMS_INITIAL_VALUES: AccessGroupItemsValues = {
  userGroupId: null,
};

export const ACCESS_GROUP_INITIAL_VALUES: AccessGroupValues = {
  name: null,
  description: null,
  accessGroupItems: [],
};
